import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import NavMobile from "./NavMobile";
import IntlMessages from "../utils/IntlMessages";
import logo from "../assets/images/new_logo.png";
import profileImage from "../assets/images/profile.png";
import { checkLogin } from "../utils/apiUtil";
import PopupLanguage from "../components/popup/language/PopupLanguage";

import {
  switchLanguage,
  toggleCollapsedNav,
  toggleCollapsedLang,
  toggleCollapsedMemberMenu,
  walletDetailFetch,
  authSignOut,
  languageOpenPopup,
} from "../actions";

class Header extends Component {
  componentDidMount() {
    if (checkLogin() === true) {
      this.props.walletDetailFetch();
    }
  }

  onChangeLang = (lang, e) => {
    //this.props.toggleCollapsedLang(false);
    this.props.languageOpenPopup();
  };

  render() {
    const {
      locale: { locale },
      authMember,
      currentPoint,
    } = this.props;
    return (
      <>
      <div className="header">
        <div className="header-wrapper">
          <div>
            <a href="/#" className="logo">
              <img src={logo} alt="Eastspring Wealth Privilege" />
            </a>
          </div>
          <div className="d-none d-md-block">
          {authMember && authMember.success  ? ( <ul className="header-nav-desktop menu">
              <li>
                <Link to="/" className="active">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li>
                <Link to="/privilege">
                  <IntlMessages id="header.privilege"></IntlMessages>
                </Link>
              </li>
              <li>
                <Link to="/faq">
                  <IntlMessages id="header.faq"></IntlMessages>
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  <IntlMessages id="header.contact"></IntlMessages>
                </Link>
              </li>
            </ul>) : (<ul className="header-nav-desktop menu">
              <li>
                <Link to="/" className="active">
                  <IntlMessages id="header.home"></IntlMessages>
                </Link>
              </li>
              <li>
                <Link to="/faq">
                  <IntlMessages id="header.faq"></IntlMessages>
                </Link>
              </li>
              <li>
                <Link to="/contact">
                  <IntlMessages id="header.contact"></IntlMessages>
                </Link>
              </li>
            </ul> )}
            <div className="header-option-desktop">
              <ul className="header-nav-desktop padding-left">
                {/*<li className=""><Link to="/#" onClick={(e)=>{alert('Search');}}><span className="icon-ico-search icon-desktop-search"></span></Link></li>*/}
                {authMember && authMember.success ? (
                  <li className="li-button">
                    <Link
                      onClick={() => {
                        this.props.authSignOut();
                      }}
                      to="/"
                    >
                      <IntlMessages id="header.logout"></IntlMessages>
                    </Link>
                  </li>
                ) : (
                  <li className="li-button">
                    <Link to="/authen">
                      <IntlMessages id="header.login"></IntlMessages>
                    </Link>
                  </li>
                )}
                <li>
                  <div
                    className="pointer btn-lang"
                    onClick={(e) => this.onChangeLang(e)}
                  >
                    {locale === "th" ? "TH" : "EN"}{" "}
                    <span className="icon icon-ico-arrow-down"></span>
                  </div>
                </li>
              </ul>
              {authMember && authMember.success ? (
                <div
                  className="desktop-profile"
                  onClick={(e) => {
                    this.props.toggleCollapsedMemberMenu();
                  }}
                >
                  <img src={profileImage} alt="Eastspring Wealth Privilege" />
                </div>
              ) : (
                ""
              )}
            </div>
            {authMember && authMember.success ? (
              <div
                className={`div-member-menu ${
                  this.props.memberMenuCollapsed ? "d-block" : "d-none"
                }`}
              >
                <div className="member-menu-triangle "></div>
                <div className="member-menu">
                  <div>
                    <Link to="/my-profile">
                      <IntlMessages id="header.profile"></IntlMessages>
                    </Link>
                  </div>
                  { false && "feature : wishlist" ? <div>
                    <Link to="/my-wishlist">
                      <IntlMessages id="header.favourite"></IntlMessages>
                    </Link>
                  </div> : ""}
                  <div>
                    <Link to="/my-coupon">
                      <IntlMessages id="header.mycoupon"></IntlMessages>
                    </Link>
                  </div>
                  <div>
                    <Link to="/history/point-transfer">
                      <IntlMessages id="header.point-history"></IntlMessages>
                    </Link>
                  </div>
                  <div
                    onClick={() => {
                      this.props.authSignOut();
                    }}
                    to="/"
                  >
                    <Link to="/">
                      <IntlMessages id="header.logout"></IntlMessages>
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

         

          <div className="header-button-container d-md-none">
            <div className="header-mobile-button mobile-search-button">
              {/*<span className="icon-ico-search icon-mobile-search"  onClick={(e)=>{alert('Search');}}></span>*/}
            </div>
            {authMember && authMember.success ? (
              <div className="header-mobile-point">
                <h6> { "Tier: " +  (authMember?.member?.memberLevel ? authMember?.member?.memberLevel : "")} </h6>
                <span className="line-point">{(currentPoint)?currentPoint.toLocaleString("en-US"):0}</span>
                <sup className="line-point-super">{(currentPoint > 1)?"points":"point"}</sup>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="header-toggle-container d-md-none">
            <span
              className="header-mobile-button mobile-menu-button"
              onClick={(e) => {
                this.props.toggleCollapsedNav();
              }}
            >
              <span className="icon-ico-menu"></span>
            </span>
          </div>
        </div>
      </div>
      <NavMobile />
      <PopupLanguage />
      </>
    );
  }
}

const mapStateToProps = ({
  setting,
  auth: { authMember },
  wallet: { detail },
}) => {
  const { locale, navCollapsed, langCollapsed, memberMenuCollapsed } = setting;
  const currentPoint = detail.point;
  return {
    locale,
    navCollapsed,
    langCollapsed,
    memberMenuCollapsed,
    authMember,
    currentPoint,
  };
};

export default connect(mapStateToProps, {
  switchLanguage,
  toggleCollapsedNav,
  toggleCollapsedLang,
  toggleCollapsedMemberMenu,
  walletDetailFetch,
  authSignOut,
  languageOpenPopup,
})(Header);
